import NavigationApp from "./navigation-app"

export default function MdxLayout({ children }: { children: React.ReactNode }) {
	return (
		<div>
			<NavigationApp />
			<div className="mx-auto max-w-4xl px-4 py-8">
				<main className="dark:prose-invert prose lg:prose-xl !text-foreground">
					{children}
				</main>
			</div>
		</div>
	)
}
